import { createApp } from 'vue'
import CustomToast from '@/components/CustomToast.vue'

// Toast实例管理
let toastInstances = []
let toastId = 0

// 创建Toast实例
function createToastInstance(options) {
  const id = ++toastId
  const container = document.createElement('div')
  container.id = `toast-${id}`
  
  const app = createApp(CustomToast, {
    ...options,
    onClose: () => {
      // 移除实例
      removeToastInstance(id)
      if (options.onClose) {
        options.onClose()
      }
    }
  })
  
  const instance = app.mount(container)
  
  // 保存实例信息
  toastInstances.push({
    id,
    app,
    container,
    instance
  })
  
  return { id, instance }
}

// 移除Toast实例
function removeToastInstance(id) {
  const index = toastInstances.findIndex(item => item.id === id)
  if (index > -1) {
    const { app, container } = toastInstances[index]
    
    // 延迟销毁，等待动画完成
    setTimeout(() => {
      app.unmount()
      if (container.parentNode) {
        container.parentNode.removeChild(container)
      }
    }, 300)
    
    toastInstances.splice(index, 1)
  }
}

// 清除所有Toast
function clearAllToasts() {
  toastInstances.forEach(({ app, container }) => {
    app.unmount()
    if (container.parentNode) {
      container.parentNode.removeChild(container)
    }
  })
  toastInstances = []
}

// 主要的Toast方法
function showToast(options) {
  // 如果传入的是字符串，转换为配置对象
  if (typeof options === 'string') {
    options = { message: options }
  }
  
  // 默认配置
  const defaultOptions = {
    type: 'info',
    duration: 3000,
    position: 'toast-center',
    showIcon: true,
    closable: false
  }
  
  const finalOptions = { ...defaultOptions, ...options }
  
  return createToastInstance(finalOptions)
}

// 便捷方法
const toast = {
  // 基础方法
  show: showToast,
  
  // 成功提示
  success(message, options = {}) {
    return showToast({
      message,
      type: 'success',
      ...options
    })
  },
  
  // 错误提示
  error(message, options = {}) {
    return showToast({
      message,
      type: 'error',
      ...options
    })
  },
  
  // 警告提示
  warning(message, options = {}) {
    return showToast({
      message,
      type: 'warning',
      ...options
    })
  },
  
  // 信息提示
  info(message, options = {}) {
    return showToast({
      message,
      type: 'info',
      ...options
    })
  },
  
  // 加载提示
  loading(message = '加载中...', options = {}) {
    return showToast({
      message,
      type: 'info',
      duration: 0, // 不自动关闭
      showIcon: false,
      ...options
    })
  },
  
  // 清除所有Toast
  clear: clearAllToasts
}

// Vue插件安装方法
toast.install = (app) => {
  app.config.globalProperties.$toast = toast
  app.provide('toast', toast)
}

export default toast
export { showToast, clearAllToasts }